module.exports = __webpack_public_path__ + "static/assets/eb658c5b4ef96595e01fe460b9385934.png";